try {
  if (process.env.REACT_APP_USE_SHADOW_ROOT === 'true') {
    const shadowHost = document.getElementById('visrez-interactive')!;
    shadowHost.attachShadow({ mode: 'open' });
  }
} catch (e) {
  console.error(e);
}

const rootElement = process.env.REACT_APP_USE_SHADOW_ROOT === 'true'
  ? document.getElementById('visrez-interactive')!.shadowRoot!
  : document.getElementById('visrez-interactive')!;

export default rootElement;
